/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FirmCompany = {
  readonly id?: number;
  readonly created_at?: string;
  readonly updated_at?: string;
  name: string;
  readonly last_audit_event_id?: string | null;
  slug?: string;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  common_profile_confirmed?: boolean | null;
  type?: FirmCompany.type;
  website?: string | null;
  legal_company_name?: string | null;
  captable_currency?: string;
  financials_currency?: string;
  is_standalone?: boolean;
  podio_id?: number | null;
  address?: string | null;
  phone_number?: string | null;
  logo_url?: string | null;
  icon_url?: string | null;
  auditor_authorized?: boolean;
  vintage_year?: number | null;
  external_id?: string | null;
  file_storage_reference?: string | null;
  attio_company_id?: string | null;
  subscription_is_active?: boolean | null;
  firm?: number | null;
  common_profile?: number | null;
  parent_company?: number | null;
  fiscal_year_end?: number | null;
};
export namespace FirmCompany {
  export enum type {
    HOLDING = 'holding',
    PORTFOLIO = 'portfolio',
    STANDALONE = 'standalone',
    INVESTMENT = 'investment',
  }
}

